import { storeCreator } from '@/utils/store/store.utils';

import { FormField } from '../../ReimburseMe.types';

export type LastEditedField = FormField.patient | FormField.serviceDate | FormField.amount | FormField.service;

export interface FilterByValues {
  patient?: string;
  service?: string;
  serviceDates?: string;
}

interface State {
  filterByValues?: FilterByValues;
  lastEditedField?: LastEditedField;
  setFilterValues: (values: FilterByValues) => void;
  setLastEditedField: (value: LastEditedField) => void;
  resetFilterValues: () => void;
}

export const useClaimInfoFieldsFilterStore = storeCreator<State>((set) => ({
  filterByValues: undefined,
  lastEditedField: undefined,

  setFilterValues: (values: FilterByValues) => set((state) => ({
    ...state,
    filterByValues: {
      ...state.filterByValues,
      ...values,
    },
  })),

  setLastEditedField: (value: LastEditedField) => set((state) => ({
    ...state,
    lastEditedField: value,
  })),

  resetFilterValues: () => set((state) => ({
    ...state,
    filterByValues: undefined,
    lastEditedField: undefined,
  })),
}));
